<template>
  <div class="onlineBg">
    <!--  设备在线情况-->
    <div id="onlineChart" style="width: 100%;height:20vh;"></div>
  </div>
</template>

<script>
import {onLineNumber} from "@/api/home";

export default {
  name: "online",
  data(){
    return {
      myChart:null,
      option:{
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [
          {
            name: '在线/离线数',
            type: 'pie',
            radius: [35, 80], // 内半径 图形宽度
            center: ['50%', '50%'],//let top
            roseType: 'radius',
            label: {
              show: true
            },
            emphasis: {
              label: {
                show: false
              }
            },
            data: [
              {value: 10, name: '在线数'},
              {value: 5, name: '离线数'},
            ],
            color: ['#38b470', '#FE5555'],
            itemStyle:{

            }
          },]
      },
      respondData:{
        offline:'',
        online:''
      },//存储接口的相应数据
      timer:null
    }
  },
  mounted() {
    this.getData()
    this.timer = setInterval(() => {
      this.getData()
    },2000)
  },
  destroyed() {
    clearInterval(this.timer)
    this.myChart.dispose() //销毁echarts 实例
  },
  methods:{
    init(){
      this.myChart = this.$echarts.init(document.getElementById('onlineChart'));
      this.myChart.setOption(this.option);
    },
    getData(){
      onLineNumber({
        jsessionId: sessionStorage.token,
      }).then(res => {
        if(res.data.code === 0){
          if(this.respondData.offline != res.data.data.offline || this.respondData.online != res.data.data.online){
            this.respondData = {
              offline:res.data.data.offline,
              online:res.data.data.online
            }
            this.option.series[0].data = [
              {value: this.respondData.online, name: '在线数'+this.respondData.online},
              {value: this.respondData.offline, name: '离线数'+this.respondData.offline},
            ]
            this.init()
          }
        }
      })
    },
    resizeChart(){
      this.myChart.resize()
    }
  }
}
</script>

<style scoped>
.onlineBg{

}
</style>
